import React, { useContext, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Col from "../../../UIcomponent/Column";
import LocalContext from "../../../Context/LocalContetxt";
import "./ProfileMenu.scss";
import { ProfileMenuItems } from "./ProfileMenuItems";
import StyledButton from "../../../UIcomponent/Button";
import StyledLink from "../../../UIcomponent/Link";
const ProfileMenu = (props) => {
  const username = "ad";
  const { id } = props;
  const config = useContext(LocalContext).config;
  const role = config && config.role;
  const [State, setState] = useState({
    selectedMenu: props.location.pathname,
    menuItems: ProfileMenuItems(),
  });
  useEffect(() => {
    setState({
      menuItems: ProfileMenuItems(window.location.pathname),
      selectedMenu: window.location.pathname,
    });
  }, [window.location.pathname]);
  const menuHandler = (value) => {
    setState({
      ...State,
      menuItems: ProfileMenuItems(value),
      selectedMenu: value,
    });
  };
  const SubClick = (KEY, value) => {
    let newMenuItems = [...State.menuItems];
    newMenuItems = newMenuItems.map((each, i) => {
      return {
        ...each,
        toggle: KEY === each.key ? (value === true ? false : true) : false,
      };
    });
    setState({
      ...State,
      menuItems: newMenuItems,
    });
  };
  return (
    <Col className="c__ProfileMenu" xl={24} lg={24} md={6} sm={6} xs={12}>
      {State.menuItems.map((menu, index) => {
        return (
          menu.neededRole.includes(role) && (
            <>
              {menu.hasSubCategory === false ? (
                <Link
                  className="o__ProfileMenu"
                  onClick={() => menuHandler(menu.absloutePath)}
                  to={`${menu.absloutePath}`}
                >
                  <Col
                    className={
                      menu.absloutePath === State.selectedMenu
                        ? "o__ProfileMenu--active"
                        : "o__ProfileMenu--none"
                    }
                  ></Col>
                  <Col
                    xl={18}
                    lg={18}
                    md={6}
                    sm={6}
                    xs={12}
                    className="o__ProfileMenu__Item"
                    style={{
                      borderBottom:
                        index !== State.menuItems.length - 1 &&
                        "1px solid #e0e0e0",
                    }}
                  >
                    {menu.name}
                  </Col>
                </Link>
              ) : (
                <Col
                  xl={24}
                  lg={24}
                  md={6}
                  sm={6}
                  xs={12}
                  className="o__ProfileMenu"
                >
                  <Col
                    className={
                      menu.subCategories.filter(
                        (each) => each.absloutePath === State.selectedMenu
                      ).length > 0
                        ? "o__ProfileMenu--active"
                        : "o__ProfileMenu--none"
                    }
                  ></Col>
                  <Col
                    xl={18}
                    lg={18}
                    md={6}
                    sm={6}
                    xs={12}
                    className="o__ProfileMenu__Item"
                    onClick={() => SubClick(menu.key, menu.toggle)}
                    style={{
                      borderBottom:
                        index !== State.menuItems.length - 1 &&
                        "1px solid #e0e0e0",
                    }}
                  >
                    {menu.name}
                  </Col>
                  <Col
                    className={` c__ProfileSubMenu ${
                      menu.toggle === true ? "subExpand" : "subCollapse"
                    }`}
                  >
                    {menu.toggle === true &&
                      menu.subCategories.map((sub) => {
                        return (
                          <Link
                            key={menu.key}
                            className="o__ProfileSubMenu"
                            onClick={() => menuHandler(menu.absloutePath)}
                            to={`${sub.absloutePath}`}
                          >
                            {
                              <Col
                                className={
                                  sub.absloutePath === State.selectedMenu
                                    ? "o__ProfileSubMenu--active"
                                    : "o__ProfileSubMenu--none"
                                }
                              ></Col>
                            }
                            <Col
                              // xl={24} lg={24} md={6} sm={6} xs={12}
                              className="o__ProfileSubMenu__Item"
                              // style={{
                              //     borderBottom: index !== State.menuItems.length - 1 && '1px solid #e0e0e0'
                              // }}
                            >
                              {sub.name}
                            </Col>
                          </Link>
                        );
                      })}
                  </Col>
                </Col>
              )}
            </>
          )
        );
      })}
      {/* {role === "Teacher" && (
        <StyledButton disabled primary>
          <StyledLink to={`/teacher/${username}`}>مشاهده پروفایل</StyledLink>
        </StyledButton>
      )} */}
    </Col>
  );
};

export default ProfileMenu;
